import qs from 'qs';
import axios, { setCommonHeader, unsetCommonHeader } from '@/axios-service';
import store from '@/store';
import router from '@/router';
import { AUTH_LOGOUT } from '@/store/auth/mutation-types';
import { AxiosRequestConfig } from 'axios';

const MS_URL = 'oauth';

let responseError401Interceptor: number;

export const integrationLogin = (credentials: { username: string; token: string }) => {
  const requestConfig = {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${credentials.token}`,
    },
  } as AxiosRequestConfig;

  let url = `uaa/parseToken/${credentials.username}`;
  
  return axios.get(url, requestConfig);
};

export const loginWithCredentials = (credentials: { username: string; password: string }) => {
  const requestBody = qs.stringify({
    grant_type: 'password',
    username: credentials.username,
    password: credentials.password,
  });

  const requestConfig = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    auth: {
      username: process.env.VUE_APP_CLIENT_ID,
      password: process.env.VUE_APP_CLIENT_SECRET,
    },
  } as AxiosRequestConfig;

  return axios.post(`${MS_URL}/token`, requestBody, requestConfig);
};

export const logoutUsingToken = (accessToken: string) => {
  const requestConfig = {
    headers: {
      'Content-Type': 'multipart/form-data',
      Token: `Bearer ${accessToken}`,
    },
    auth: {
      username: process.env.VUE_APP_CLIENT_ID,
      password: process.env.VUE_APP_CLIENT_SECRET,
    },
  } as AxiosRequestConfig;

  return axios.delete(`${MS_URL}/token`, requestConfig);
};

export const setAuthorizationHeader = (accessToken: string) => {
  setCommonHeader('Authorization', `Bearer ${accessToken}`);
};

export const unsetAuthorizationHeader = () => {
  unsetCommonHeader('Authorization');
};

export const addResponseError401Interceptor = () => {
  responseError401Interceptor = axios.interceptors.response.use(
    undefined,
    (err: { request: { status: number }; config: { __isRetryRequest: any } }) => {
      // eslint-disable-next-line no-underscore-dangle
      console.log(err.request);
      if (sessionStorage.getItem('integration') !== 'true') {
        if (err.request.status === 401 && err.config && !err.config.__isRetryRequest) {
          store.dispatch(`auth/${AUTH_LOGOUT}`, router.currentRoute.fullPath);
        }
        return Promise.reject(err); 
      }
    },
  );
};

export const removeResponseError401Interceptor = () => {
  axios.interceptors.response.eject(responseError401Interceptor);
  responseError401Interceptor = 0;
};
